module.exports = __webpack_public_path__ + "media/images/lb/268-c527962421740e90022f1e46a0b73f2b.svg";